import "./App.css";
import AboutCapitalAcres from "./components/AboutCapitalAcres";
import AboutDeveloper from "./components/AboutDeveloper";
import Amenities from "./components/Amenities";
import BestQuotes from "./components/BestQuotes";
import Carousel from "./components/Carousel";
import Details from "./components/Details";
import FloorPlan from "./components/FloorPlan";
import Footer from "./components/Footer";
import Form from "./components/Form";
import Header from "./components/Header";
import Hero from "./components/Hero";
import StripSection from "./components/StripSection";
import Pricing from "./components/Pricing";
import NewForm from "./components/NewForm";
import LocationBenefits2 from "./components/LocationBenefits2";
import { useEffect } from "react";

function App() {
  const project = "Rustomjee Balmoral Chembur"

  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();

    // Disable F12 and Ctrl+Shift+I
    const handleKeyDown = (e) => {
      if (e.key === "F12" || (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i") || (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "c")) {
        e.preventDefault();
      }
    };

    // Attach event listeners
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup event listeners
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []); // Empty array means it runs once on mount
  return (
    <div className="App">
      <Header />
      <Hero />
      <NewForm />
      <StripSection />
      <Details project={project} />
      <Pricing project={project}/>
      <FloorPlan project={project}/>
      <Amenities project={project}/>
      <Carousel project={project}/>
      <LocationBenefits2 project={project}/>
      <AboutDeveloper project={project}/>
      <AboutCapitalAcres />
      <BestQuotes />
      <Footer />
      <Form />
    </div>
  );
}

export default App;
